<script setup lang="ts">
interface TypingConfig {
  step?: number;
  interval?: number;
}

interface FogConfig {
  bgColor?: string;
}

const props = withDefaults(defineProps<{
  content?: string;
  typing?: TypingConfig;
  isFog?: FogConfig;
}>(), {
  content: '',
  typing: () => ({ step: 1, interval: 50 }),
  isFog: () => ({ bgColor: '#fff' }),
});

const displayText = ref('');
const isComplete = ref(false);
let animFrame = 0;
let pos = 0;

function type() {
  if (!props.content)
    return;
  const step = props.typing?.step ?? 1;
  const interval = props.typing?.interval ?? 50;
  const totalLen = props.content.length;

  let lastTime = performance.now();

  function animate(now: number) {
    if (pos >= totalLen) {
      isComplete.value = true;
      displayText.value = props.content!;
      cancelAnimationFrame(animFrame);
      return;
    }

    const elapsed = now - lastTime;
    if (elapsed >= interval) {
      const chars = Math.min(step, totalLen - pos);
      pos += chars;
      displayText.value = props.content!.slice(0, pos);
      lastTime = now;
    }

    animFrame = requestAnimationFrame(animate);
  }

  displayText.value = '';
  isComplete.value = false;
  pos = 0;
  animFrame = requestAnimationFrame(animate);
}

watch(() => props.content, () => {
  cancelAnimationFrame(animFrame);
  if (props.content) {
    type();
  }
  else {
    displayText.value = '';
    isComplete.value = false;
    pos = 0;
  }
}, { immediate: true });

onUnmounted(() => {
  cancelAnimationFrame(animFrame);
});
</script>

<template>
  <div class="typer-container" :style="{ position: 'relative', display: 'inline-block' }">
    <span class="typer-content">{{ displayText }}</span>
    <span
      v-if="!isComplete && content"
      class="typer-cursor"
    >|</span>
    <!--    <div -->
    <!--      v-if="isFog?.bgColor" -->
    <!--      class="typer-fog" -->
    <!--      :style="{ -->
    <!--        background: `linear-gradient(to right, transparent 0%, ${isFog.bgColor} 100%)`, -->
    <!--      }" -->
    <!--    /> -->
  </div>
</template>

<style scoped lang="scss">
.typer-container {
  position: relative;
  display: inline-block;
  overflow: initial;
}

.typer-content {
  word-break: break-all;
}

.typer-cursor {
  display: inline;
  animation: typer-blink 1s step-end infinite;
  color: var(--el-color-primary);
  font-weight: 400;
}

@keyframes typer-blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

.typer-fog {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  pointer-events: none;
}
</style>
